<div class="flex flex-col gap-5">
  <app-analysis-consumption-filters
    [filter]="filter()"
    [showLocationsSelect]="false"
    [energyInterfacesLoading]="energyInterfaces.isLoading()"
    [energyInterfaces]="energyInterfaces.hasValue() ? energyInterfaces.value().items : []"
    (changeFilter)="onChangeConsumptionFilters($event)"
  />

  <app-analysis-consumption-graph-card
    [filter]="filter()"
    [state]="data()"
    [organizationId]="organizationId()"
    (changeDate)="onChangeDate($event)"
    (changeGranularity)="onChangeGranularity($event)"
    (clickReload)="clickReload.emit(this.filter())"
  />

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
    <app-analysis-consumption-details-kpi-card [filter]="filter()" [state]="data()" />
    <app-analysis-consumption-details-peakload-kpi-card [filter]="filter()" [state]="data()" />
  </div>
</div>
